<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      キャンセルポリシー・注意点
    </Header>

    <CancelPolicyContent />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import CancelPolicyContent from "@/components/organisms/order/CancelPolicyContent.vue";
import { applicationService } from "@/app/services/ApplicationService";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";

@Component({
  components: {
    FeatherIcon,
    Header,
    CancelPolicyContent
  }
})
export default class ApplicationCancelPolicy extends Vue {
  get applicationId() {
    return Number(this.$route.params.applicationId);
  }

  /* 
      NOTE: TypeScriptに修正前と同じ動きを担保するために fetch している。
            fetchした内容は何にも使っていないのと、
            このコンポーネント自体がキャンセルポリシーを表示するのみのものなのでこの処理自体不要かと思われる。
  */
  async created() {
    try {
      await applicationService.fetchApplication(this.applicationId);
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    }
  }

  async onClickBack() {
    await this.$router.replace({
      name: "ApplicationCancelReason",
      params: {
        applicationId: String(this.applicationId)
      }
    });
  }
}
</script>
